import { useEffect, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { fetchTourOperators } from 'actions/TourV2Actions'
import { nonNullable } from 'lib/arrayUtils'

const emptyOperators: { fetching: boolean, operators: Record<string, Tours.TourOperator> } = { fetching: true, operators: {} }

function useTourOperators(): {fetching: boolean, operators: Array<Tours.TourOperator>} {
  const dispatch = useAppDispatch()
  const tourOperators = useAppSelector((state) => state.tour.tourOperators ?? emptyOperators)

  useEffect(() => {
    dispatch(fetchTourOperators())
  }, [dispatch, tourOperators])

  const operators = useMemo(() => {
    const { fetching = true, operators } = tourOperators
    let operatorsSorted = []
    if (!fetching && operators && Object.values(operators).length > 0) {
      operatorsSorted = [
        operators?.luxuryescapes,
        operators?.abercrombiekent,
        operators?.luxurygold,
        operators?.trafalgar,
        operators?.aatkings,
        operators?.insightvacations,
      ]
    }
    return {
      fetching,
      operators: nonNullable<Tours.TourOperator>(operatorsSorted),
    }
  }, [tourOperators])

  return operators
}

export default useTourOperators
